export default "__VITE_ASSET__B1nregi4__"